import React from 'react'

import type { SelfValidateInputRef, SelfValidateTextAreaRef } from '@/shared/ui'
import { Button, Popover } from 'antd'
import { type FormikContextType } from 'formik'

import { type GreetingFormModel } from '../../'

const USERNAME_TAG_STRING = '{username}'

const popoverContent = (
  <span>
    Вы можете добавить имя пользователя с помощью команды{' '}
    <span style={{ color: '#D48806' }}>{USERNAME_TAG_STRING}</span>
  </span>
)

interface InsertUsernameTagButtonProps {
  inputRef: React.RefObject<
    SelfValidateInputRef | SelfValidateTextAreaRef | null
  >
  fieldName: Extract<keyof GreetingFormModel, 'description' | 'title'>
  formik: FormikContextType<GreetingFormModel>
}

export const InsertUsernameTagButton: React.FC<
  InsertUsernameTagButtonProps
> = ({ inputRef, fieldName, formik }) => {
  const handleClick = () => {
    const { start, end } = inputRef.current?.getSelection() ?? {
      start: 0,
      end: 0,
    }
    const currentValue = formik.values[fieldName]
    const insertText = USERNAME_TAG_STRING
    const newValue =
      currentValue.slice(0, start) + insertText + currentValue.slice(end)

    void formik.setFieldValue(fieldName, newValue)

    setTimeout(() => {
      inputRef.current?.focus()
      inputRef.current?.setSelection(start + insertText.length)
    }, 0)
  }

  return (
    <Popover
      title="Подсказка"
      content={popoverContent}
      trigger="hover"
      placement="left"
      destroyOnHidden
    >
      <Button style={{ width: 'fit-content' }} onClick={handleClick}>
        Вставить имя пользователя
      </Button>
    </Popover>
  )
}

export default InsertUsernameTagButton
